<template>
  <div class="is-marginless is-paddingless section section-details" v-if="detailDevisCommande">
    <div class="pdt-20px">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3" v-if="!detailDevisCommande">
                {{ $t('detail.titleFacture') }}</h1>
              <h1 class="title is-size-3">
                {{ detailDevisCommande.generalInfos.title }}
                n°: {{ detailDevisCommande.code }}</h1>
              <tag-list
                class="mgb-0"
                v-if="factureTags.length > 0"
                :listes="factureTags"/>
              <app-breadcrumb :breadcrumb="breadcrumb" />
            </div>
          </div>
        </div>
        <a ref="lienDownload"></a>
        <div class="level-right" v-if="canSeeFacture">
          <div class="buttons">
            <div class="button is-addOrEdit" @click="popUpRemiseReglement = true"
                 v-if="detailDevisCommande.etat !== paye && devisCommande.sousType === accompte
                  && activeButtonEtLien">
              {{ $t('detail.buttons.payer') }}
            </div>
            <dropdownButton
              v-if="etatBrouillon && activeButtonEtLien"
              type="is-addOrEdit"
              class="mgr-2"
              :permission="permFactures.maj"
              :actions="actionButton"
              @click="() => { $router.push({name: 'm.bodac.factures-edition'}) }">
              {{ $t('detail.buttons.edit') }}&nbsp;
            </dropdownButton>
            <button class="button is-addOrEdit"
                    v-if="peutEtreEditEcheancier && activeButtonEtLien"
                    :class="{'button-access-no-permission': !checkPermissions(permFactures.maj)}"
                    @click="checkPermissions(permFactures.maj) ?
                    $router.push({ name: 'm.bodac.factures-editionEcheancierPaiement',
                    params: { idFacture: detailDevisCommande.id }}) : showPopUp()">
              {{ $t('detail.buttons.editEcheancier') }}
            </button>
            <button class="button is-addOrEdit"
                    v-if="peutEtreAnnule && activeButtonEtLien"
                    :class="{'button-access-no-permission': !checkPermissions(permFactures.maj)}"
                    @click="checkPermissions(permFactures.maj) ? annulationFacture()
                    : showPopUp()">
              {{ $t('detail.buttons.cancelFacture') }}
            </button>
            <button v-if="etatBrouillon && activeButtonEtLien"
                    class="button is-addOrEdit"
                    :class="{'button-acces-no-permission': !checkPermissions(permFactures.maj)}"
                    @click="checkPermissions(permFactures.maj) ?
                    isFactureDefinitifOpen = true : showPopUp()">
              {{ $t('detail.buttons.save') }}&nbsp;
            </button>
            <button class="button" v-if="activeButtonEtLien">
              <b-dropdown position="is-bottom-left" aria-role="list" class="has-text-left">
                <a slot="trigger">
                  <b-icon class="is-flex"
                          custom-class="has-text-icon-more"
                          icon="dots-vertical">
                  </b-icon>
                </a>
                <b-dropdown-item
                  @click="popUpRemiseReglement = true"
                  v-if="estAutomatiquementPayable">
                  {{ $t('detail.buttons.payerAutomatiquement') }}
                </b-dropdown-item>
                <b-dropdown-item
                  @click="checkPermissions(permFactures.maj) ?
                    generateEcritureComptable() : showPopUp()"
                  v-if="detailDevisCommande.etat !== brouillon && devisCommande.montantTtc !== 0">
                  {{ $t('detail.buttons.generateEcriture') }}
                </b-dropdown-item>
                <b-dropdown-item
                  @click="popUpSolderManuellement()"
                  v-if="detailDevisCommande.etat !== brouillon
                  && detailDevisCommande.etat !== paye
                  && devisCommande.montantTtc !== 0
                  && detailDevisCommande.sousType !== avoir
                  && detailDevisCommande.sousType !== avoirSurAcompte">
                  {{$t('detailFacture.buttons.solderManuellement')}}
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="detailDevisCommande.etat === paye
                  && devisCommande.montantTtc !== 0
                  && detailDevisCommande.sousType !== avoir
                  && detailDevisCommande.sousType !== avoirSurAcompte"
                  @click="openPopUpAnnulerSolde = true">
                  {{$t('detailFacture.buttons.annulerSoldeManuel')}}
                </b-dropdown-item>
                <b-dropdown-item v-if="devisCommande"
                 @click="checkPermissions(permFactures.exporter)
                  ? exporterLigneVente() : showPopUp()">
                  {{ $t('detail.buttons.exporterLignesVentes') }}
                </b-dropdown-item>
              </b-dropdown>
            </button>
            <button class="button" v-if="!isAcompte && !isAvoir
                    && !isFactureBailleur && activeButtonEtLien"
                    @click="openPopUpValidationCopy = true">
              <b-icon icon="file-multiple" type="is-default"></b-icon>
            </button>
            <mail-button
              class="mgr-2"
              :perm="permFactures.lecture"
              :titlePopUp="'detailFacture.popUpMail.title'"
              :dcfDetail="detailDevisCommande"
              :editionsAInclure="editionsAInclure"
              :mailSetUp="mailSetUp">
            </mail-button>
            <button class="button"
                    @click="$refs.dropdownEdition.toggle()" v-if="!isFactureBailleur">
              <div>
                <b-icon icon="file-download" class="mgr-10px" type="is-default"></b-icon>
                <b-dropdown
                  ref="dropdownEdition"
                  position="is-bottom-left"
                  class="has-text-left">
                  <div slot="trigger">
                    <b-icon icon="chevron-down"
                            class="has-text-secondary-icon">
                    </b-icon>
                  </div>
                  <b-dropdown-item
                    @click="checkPermissions(permFactures.editer) ?
                edition({format: pdf,
                typeDonnee: constantes.TYPE_EDITION_FACTURE }) : showPopUp()">
                    {{ $t('general.popUpEdition.type.pdf') }}
                  </b-dropdown-item>
                  <b-dropdown-item
                    @click="checkPermissions(permFactures.editer) ?
                edition({format: docx,
                typeDonnee: constantes.TYPE_EDITION_FACTURE}) : showPopUp()">
                    {{ $t('general.popUpEdition.type.docx') }}
                  </b-dropdown-item>
                  <b-dropdown-item
                    @click="checkPermissions(permFactures.editer) ?
                     showPdfViewer = true : showPopUp()">
                    {{ $t('general.previsualisation') }}
                  </b-dropdown-item>
                  <b-dropdown-item
                    @click="checkPermissions(permFactures.editer) ?
                popUpEdition = true : showPopUp()">
                    {{ $t('general.popUpEdition.type.other') }}
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </button>
            <button class="button" v-if="!isFactureBailleur && activeButtonEtLien">
              <b-dropdown position="is-bottom-left" aria-role="list">
                <a slot="trigger">
                  <b-icon class="is-flex"
                          custom-class="has-text-icon-more"
                          icon="call-split">
                  </b-icon>
                </a>
                <b-dropdown-item
                  has-link>
                  <router-link-blank
                    classComposant="noTextDecoration"
                    classMessage="is-block"
                    :to="{
                    name: 'l.bodac.commandes-echeances'}"
                    :message="$t('detail.buttons.aFacturer')" >
                  </router-link-blank>
                </b-dropdown-item>
              </b-dropdown>
            </button>
            <piece-jointe-button
              v-if="activeButtonEtLien"
              class="mgr-2"
              :perm="permFactures.maj"
              autoSave>
            </piece-jointe-button>
          </div>
        </div>
      </div>
      <div v-if="canSeeFacture && !activeButtonEtLien">
        <app-information-msg-component :title="'general.info'"
                                       :libelleList="[{ isLink: false,
                                       libelle: $t('detail.infos.facture') }]"
                                       :canClose="false">
        </app-information-msg-component>
      </div>
      <div class="tab" v-if="canSeeFacture">
        <ul>
          <li @click="activeTab = 'FactureDetail'"
              :class="{'is-active': activeTab === 'FactureDetail'}">
            {{ $t('detail.ongletFacture.facture')}}
          </li>
          <li :class="{ 'is-active': activeTab === 'achatVenteInterne' }"
              @click="activeTab = 'achatVenteInterne'"
              v-if="siteHasHolding && !isFactureBailleur">
            <b-field>
              <div class="mgv-auto mgr-5px"
                   :class="getColorStatuFactureAchat"></div>
              <span> {{ $t('detail.ongletFacture.achats') }} </span>
            </b-field>
          </li>
          <li @click="activeTab = 'DetailAchatFacture'"
              :class="{'is-active': activeTab === 'DetailAchatFacture'}"
              v-if="moduleAchatAASpe">
            {{ $t('detail.ongletFacture.achats')}}
          </li>
          <b-tooltip v-if="devisCommande.montantTtc === 0 && detailDevisCommande.id"
                     :label="$t('detailFacture.ecritureComptable.montantTtcZero')">
            <li class="pointer-events-none text-access-no-permission">
              {{ $t('detail.ongletFacture.ecritureCompta')}}
            </li>
          </b-tooltip>
          <li v-show="devisCommande.regleFacturation === null
          || (devisCommande.regleFacturation !== null
          && devisCommande.regleFacturation.type === 0)"
          @click="activeTab = 'EcrituresComptaDetail'"
              v-if="detailDevisCommande.id && devisCommande.montantTtc !== 0"
              :class="{'is-active': activeTab === 'EcrituresComptaDetail'}">
            {{ $t('detail.ongletFacture.ecritureCompta')}}
          </li>
          <li :class="{'is-active': activeTab === 'previsualisation'}"
              @click="activeTab = 'previsualisation'" v-if="!isFactureBailleur">
            {{ $t('detail.ongletFacture.previsualisation') }}
          </li>
          <li :class="{'is-active': activeTab === 'commissionsFournisseur'}"
              v-if="modulePresseActive"
              @click="activeTab = 'commissionsFournisseur'">
            {{ $t('detail.ongletFacture.commissionFournisseur') }}
          </li>
          <li :class="[{'is-active': activeTab === 'commissions'}]"
            @click="activeTab = 'commissions'" v-if="modulePresseActive">
            {{ $t('editionCommande.tabs.commissions') }}
          </li>
          <li :class="{'is-active': activeTab === 'AppFactor'}"
              v-if="moduleFactorActive && !isAcompte"
              @click="activeTab = 'AppFactor'">
            {{ $t('detail.ongletFacture.factor') }}
          </li>
          <li :class="{'is-active': activeTab === 'listeRelancesCommun'}"
              @click="activeTab = 'listeRelancesCommun'">
            {{ $t('detail.ongletFacture.relance') }}
          </li>
        </ul>
      </div>
      <div v-else>
        <app-information-msg-component :title="'general.info'"
                                       :libelleList="[{ isLink: false,
                                       libelle: $t('general.noAccess') }]"
                                       :canClose="false"
        >
        </app-information-msg-component>
      </div>
    </div>
    <div v-if="canSeeFacture">
      <component :is="activeTab"
                 :isEdit="false"
                 :dcf="devisCommande"
                 :facturesAchat="facturesAchat"
                 :detailDevisCommande="detailDevisCommande"
                 :devisCommande="devisCommande"
                 :facture="devisCommande"
                 @reloadFactureAchat="loadFactureAchat"
                 :id="detailDevisCommande.id"
                 :dateDernierExport="devisCommande.dernierExportComptable"
                 :ecritures="ecritures"/>
    </div>
    <b-modal v-model="deleteFacture"
             has-modal-card
             class="modal">
      <confirmation-suppression-commande
        :devisCommandes="factureASupp"
        @rechargement="rechargementSuiteSuppression()"
        :type="type"/>
    </b-modal>
    <b-modal v-model="isFactureDefinitifOpen" v-if="detailDevisCommande"
             has-modal-card
             class="modal"
             width="25vw"
             @close="isFactureDefinitifOpen = false">
      <app-confirmation-enregistrement-definitif :isAvoir="isAvoir" :facture="devisCommande"/>
    </b-modal>
    <b-modal v-model="popUpAvoir" has-modal-card class="modal" v-if="detailDevisCommande"
      width="30vw">
      <app-pop-up-avoir :id="detailDevisCommande.id" :code="detailDevisCommande.code"
                        :factureInformation="devisCommande"
                        :withLettrageLettre="checkEtatLettrageLettreAndEtatFacture"
                        :sousType="devisCommande.sousType">
      </app-pop-up-avoir>
    </b-modal>
    <b-modal v-model="popUpRemiseReglement" has-modal-card class="modal">
      <app-remise-bancaire-reglement @close="popUpRemiseReglement = false"
                                     :detailDevisCommande="this.detailDevisCommande"
                                     :isFactureNormal="isFactureNormal">
      </app-remise-bancaire-reglement>
    </b-modal>
    <b-modal v-model="popUpEdition" has-modal-card class="modal">
      <pop-up-edition
        :choiceEdition="getChoiceEdition"
        :error="errorEdition"
        @editionChoose="edition"
      >
      </pop-up-edition>
    </b-modal>
    <b-modal v-model="openPopUpPrevention" has-modal-card class="modal">
      <pop-up-prevention
        :mess-header="$t('detailFacture.popups.confirmationSolderManuellement')"
        :cancel="$t('general.button.cancel')"
        :validate="$t('general.button.appliquer')"
        :isErrorPopup.sync='isErrorPopup'
        :messagesPopup='messagesPopup'
        @yes="solderManuellement"
        @no="closePopupSolderManuellement">
      </pop-up-prevention>
    </b-modal>
    <b-modal v-model="openPopUpValidationCopy" has-modal-card class="modal">
      <pop-up-prevention
        :mess-header="$t('detailFacture.popups.confirmationCopieFacture',
        { code: detailDevisCommande.code })"
        :cancel="$t('general.button.cancel')"
        :validate="$t('general.button.next')"
        @yes="copy"
        @no="openPopUpValidationCopy = false">
      </pop-up-prevention>
    </b-modal>
    <b-modal v-model="openPopUpAnnulerSolde" has-modal-card class="modal">
      <pop-up-prevention
        :mess-header="$t('detailFacture.popups.confirmationAnnulerSoldeManuel')"
        :cancel="$t('general.button.cancel')"
        :validate="$t('general.button.appliquer')"
        :isErrorPopup.sync='isErrorPopup'
        :messagesPopup='messagesPopup'
        @yes="annulerSoldeManuelFacture"
        @no="closePopupAnnulerSoldeManuel">
      </pop-up-prevention>
    </b-modal>
    <transition
      name="custom-classes-transition"
      enter-active-class="animate__animated animate__slideInRight"
      leave-active-class="animate__animated animate__slideOutRight"
      :duration="900">
      <pdf-viewer
        v-if="showPdfViewer"
        :payload-edition="{
          ids: [detailDevisCommande.id],
          typeDonnee: constantes.TYPE_EDITION_FACTURE,
        }"
        @closed="showPdfViewer = false"
      />
    </transition>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import AppBreadcrumb from '@/components/general/breadcrumb';
import { generateByFacture, getByFacture } from '@/api/compta/ifEcriture/index';
import { get, pSolderManuellement, annulerSoldeManuel } from '@/api/facture/index';
import edition from '@/api/edition/index';
import detailDevisCommande from '@/services/devisCommandes/detailDevisCommande';
import * as devisConf from '@/configuration/devisConf';
import {
  LISTE_CHOICE_EDITION_FACTURE,
  TYPE_EDITION_FACTURE,
  TYPE_EDITION_FACTURE_MAIL,
  TYPE_EDITION_FACTURE_LETTRE_ANNULATION1,
  TYPE_EDITION_FACTURE_LETTRE_ANNULATION2,
  EXPORT_EXCEL_LIGNE_FACTURE,
} from '@/configuration/facture/factureConf';
import confirmationEnregistrementDefinitif from '@/components/factures/confirmationEnregistrementDefinitif';
import messageErreur from '@/services/general/messageErreur';
import { FACTURES } from '@/configuration/permissionsBodacConf';
import popUpRemiseBancaireReglement from '@/components/devisCommandes/detailDevisCommande/popUpRemiseBancaireReglement';
import getInfoEcheancierPaiement from '@/services/echeancePaiement/getInformationEcheancierPaiement';
import { LETTRE, NON_LETTRE } from '@/configuration/lettrageConf';
import FactureDetail from '@/components/factures/factureDetail';
import EcrituresComptaDetail from '@/components/commun/ecritureComptable/ecrituresComptaDetail';
import { get as getTiers } from '@/api/tiers/index';
import popUpEdition from '@/components/factures/p_edition';
import { TYPE_PDF, TYPE_DOCX } from '@/configuration/edition/editionConf';
import messageSucces from '@/services/general/messageSucces';
import previsualisation
  from '@/components/devisCommandeFacture/previsualisation/previsualisation';
import copyFacture from '@/services/facture/copyFacture';
import { SET_COMMANDE } from '@/store/modules/commande-mutation-type';
import { COMMERCIAL } from '@/configuration/parametrage/utilisateurConf';
import { NO_PAGINATION } from '@/configuration/clientTableConf';
import { cloneDeep } from 'lodash';
import { getAll } from '@/api/commande';
import AppInformationMsgComponent from '@/components/general/informationMsgComponent';
import validationGeneral from '@/services/validation/validation';
import translate from '@/services/devisCommandes/validation/champsFactureTranslator';
import validationDevisCommande from '@/services/devisCommandes/validation/validation';
import { TYPE_VENTE } from '@/configuration/compta/ecritureConf';
import readErrorBlobRequest from '@/services/edition/readBlobRequest';
import { PARAMETRES_INTERNE_KEYS, PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import popUpPrevention from '@/components/general/popUpPrevention';
import validationFacture from '@/services/facture/validation/validationSolderManuellement';
import DetailAchatFacture from '@/components/devisCommandes/achat/detailAchatCommande';
import loadFactureAchatVenteInterne
  from '@/services/facture/factureAchat/loadFactureAchatVenteInterne';
import commissions from '@/components/devisCommandes/detailDevisCommande/commissionsCommande';
import achatVenteInterne from '@/components/bodac/facture/detail/achatVenteInterne';
import { get as getPlanMedia } from '@/api/planMedia';
import { siteHasHolding } from '@/services/general/holding';
import commissionsFournisseur from '@/components/factures/detail/commissionsFournisseur';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import AppFactor from '@/components/factures/detail/factor';
import mailButton from '@/components/general/button/mailButton';
import pieceJointeButton from '@/components/general/button/pieceJointeButton';
import listeRelancesCommun from '@/views/bodac/relancesCommun/l_relances';
import pdfViewer from '@/components/general/pdfViewer';
import dropdownButton from '@/components/general/button/dropdownButton';
import exportExcel from '@/api/exportExcel';
import { TYPE_DONNEE_DIAPORAMA } from '@/configuration/catalogue/produitConf';
import tagList from '@/components/general/tagList';
import popUpAvoir from './popUpAvoir';
import confirmationSuppressionCommande from '../confirmationSuppressionCommande';

const Attachments = createNamespacedHelpers('attachments');
const permissions = createNamespacedHelpers('permissions');
const Commandes = createNamespacedHelpers('commande');
const User = createNamespacedHelpers('user');
const Societe = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'detail-facture',
  props: [],
  components: {
    routerLinkBlank,
    dropdownButton,
    appBreadcrumb: AppBreadcrumb,
    appPopUpAvoir: popUpAvoir,
    confirmationSuppressionCommande,
    appConfirmationEnregistrementDefinitif: confirmationEnregistrementDefinitif,
    appRemiseBancaireReglement: popUpRemiseBancaireReglement,
    FactureDetail,
    EcrituresComptaDetail,
    popUpEdition,
    previsualisation,
    AppInformationMsgComponent,
    popUpPrevention,
    DetailAchatFacture,
    achatVenteInterne,
    commissionsFournisseur,
    commissions,
    AppFactor,
    mailButton,
    pieceJointeButton,
    listeRelancesCommun,
    pdfViewer,
    tagList,
  },
  data() {
    return {
      popUpAvoir: false,
      openPopUpPrevention: false,
      isFactureDefinitifOpen: false,
      error: false,
      popUpRemiseReglement: false,
      champsVide: [],
      detailDevisCommande: null,
      devisCommande: null,
      payeurSelected: null,
      deleteFacture: false,
      factureASupp: [],
      type: devisConf.TYPE_FACTURE,
      normal: devisConf.SOUS_TYPE_NORMAL,
      avoir: devisConf.SOUS_TYPE_AVOIR,
      avoirSurAcompte: devisConf.SOUS_TYPE_AVOIR_SUR_ACOMPTE,
      accompte: devisConf.SOUS_TYPE_ACOMPTE,
      brouillon: devisConf.ETAT_BROUILLON,
      paye: devisConf.ETAT_PAYE,
      permFactures: FACTURES,
      activeTab: 'FactureDetail',
      popUpEdition: false,
      choiceEdition: LISTE_CHOICE_EDITION_FACTURE,
      pdf: TYPE_PDF,
      docx: TYPE_DOCX,
      mail: null,
      ecritures: [],
      errorEmail: {
        haveError: false,
        messages: [],
      },
      errorEdition: {
        haveError: false,
        messages: [],
        champsVide: [],
        messagesChampsVide: [],
      },
      constantes: {
        TYPE_EDITION_FACTURE,
        EXPORT_EXCEL_LIGNE_FACTURE,
      },
      sensAchat: devisConf.SENS_ACHAT,
      referenceExterneTypeContrat: devisConf.REFERENCE_EXTERNE_CONTRAT,
      editionsAInclure: [{
        libelle: 'detailFacture.popUpMail.inclureFacture', key: 'mettreEdition', value: true, type: TYPE_EDITION_FACTURE_MAIL,
      }],
      actionButton: [{
        label: this.$t('detail.buttons.delete'),
        permissionAction: FACTURES.supprimer,
        action: () => {
          this.deleteFacture = true;
        },
      }],
      messagesPopup: [''],
      isErrorPopup: false,
      openPopUpValidationCopy: false,
      facturesAchat: [],
      openPopUpAnnulerSolde: false,
      showPdfViewer: false,
    };
  },
  computed: {
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Societe.mapGetters({
      societesInformations: 'societesInformations',
    }),
    mailSetUp() {
      return {
        parametreAgenceCorpMail: 'emailFacturation',
        objet: this.$i18n.t('detailFacture.popUpMail.factureObject', {
          code: this.detailDevisCommande.code,
          date: this.detailDevisCommande.generalInfos.dateDevisCommande,
        }),
        contactDCFTitle: this.$t('detailFacture.popUpMail.contactTitle'),
      };
    },
    modulePresseActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.modulePresse.key);
    },
    moduleFactorActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleFactor.key);
    },
    moduleAchatAASpe() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.achatAASpe.key);
    },
    getColorStatuFactureAchat() {
      if (this.facturesAchat.length === 0) return '';
      let statusVenteInterne = 0;
      const listeFacturesAchatWithVI = this.facturesAchat.filter(fa => {
        return fa.factureVenteInterne != null && fa.factureVenteInterne !== undefined;
      });
      if (listeFacturesAchatWithVI.length > 0) {
        statusVenteInterne = [...new Set(listeFacturesAchatWithVI
          .map(c => c.factureVenteInterne.etat))];
      }
      const status = [...new Set(this.facturesAchat.map(f => f.etat))];
      if (status.length > 1 || statusVenteInterne > 1 || (status[0] !== statusVenteInterne[0])) return 'round-circle-warning';
      return status[0] === devisConf.ETAT_BROUILLON || statusVenteInterne[0] === devisConf.ETAT_BROUILLON ? 'round-circle-danger' : 'round-circle-success';
    },
    siteHasHolding() {
      return siteHasHolding();
    },
    checkEtatLettrageLettreAndEtatFacture() {
      return (this.detailDevisCommande.echeancierPaiement.some((echeance) => {
        return echeance.etatLettrage === LETTRE;
      }) && this.detailDevisCommande.etat !== devisConf.ETAT_ANNULER);
    },
    ...User.mapGetters({
      user: 'user',
      site: 'site',
    }),
    canSeeFacture() {
      if (!this.parametresInterne(
        PARAMETRES_INTERNE_KEYS.blocageFiltreCommercial.key)) return true;
      return ((this.user.profil === COMMERCIAL
        && this.devisCommande.commercialId === this.user.id)
        || this.user.profil !== COMMERCIAL);
    },
    isFactureNormal() {
      return this.devisCommande.etat === devisConf.ETAT_ENREGISTRE
        && this.devisCommande.sousType === devisConf.NORMAL;
    },
    isFactureBailleur() {
      return this.devisCommande.typeReferenceExterne === this.referenceExterneTypeContrat
        && this.devisCommande.sens === this.sensAchat;
    },
    isAcompte() {
      return this.devisCommande.sousType === devisConf.SOUS_TYPE_ACOMPTE;
    },
    isAvoir() {
      return [devisConf.SOUS_TYPE_AVOIR,
        devisConf.SOUS_TYPE_AVOIR_SUR_ACOMPTE].includes(this.devisCommande.sousType);
    },
    getChoiceEdition() {
      let clonedChoiceEdition = cloneDeep(this.choiceEdition);
      clonedChoiceEdition.forEach(item => {
        if (item.extra) {
          delete item.extra;
        }
      });
      if (!this.moduleCBADiaporama) {
        clonedChoiceEdition = clonedChoiceEdition.filter(l => {
          return l.libelle !== 'catalogue.edition.diaporama';
        });
      }
      if (this.devisCommande.typeReferenceExterne !== devisConf
        .REFERENCE_EXTERNE_ANNULATION_REGLEMENT) {
        clonedChoiceEdition = clonedChoiceEdition.filter(e => {
          return e.typeEdition !== TYPE_EDITION_FACTURE_LETTRE_ANNULATION1
            && e.typeEdition !== TYPE_EDITION_FACTURE_LETTRE_ANNULATION2;
        });
      }
      if (this.isAcompte || this.isAvoir) {
        clonedChoiceEdition.splice(4, 1);
      }
      return clonedChoiceEdition;
    },
    estAutomatiquementPayable() {
      return this.devisCommande.etat === devisConf.ETAT_ENREGISTRE
        && this.devisCommande.sousType === devisConf.NORMAL
        && !this.devisCommande.echeancierPaiement.some((echeance) => {
          return echeance.etatLettrage !== NON_LETTRE;
        });
    },
    breadcrumb() {
      const output = [
        { title: this.$i18n.t('listeFactures.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('listeFactures.title'), route: { name: 'l.bodac.factures' }, isActive: false },
        { title: this.detailDevisCommande.generalInfos.title, route: { name: 'c.bodac.factures' }, isActive: true },
      ];
      return output;
    },
    etatBrouillon() {
      return this.detailDevisCommande
          && this.detailDevisCommande.etat === devisConf.ETAT_BROUILLON;
    },
    peutEtreAnnule() {
      return this.detailDevisCommande && !this.isFactureBailleur
        && (((this.detailDevisCommande.etat === devisConf.ETAT_ENREGISTRE
          || this.checkEtatLettrageLettreAndEtatFacture)
        && this.devisCommande.sousType === devisConf.SOUS_TYPE_NORMAL)
        || this.isAcompte);
    },
    peutEtreEditEcheancier() {
      return this.detailDevisCommande && !this.isFactureBailleur
        && this.detailDevisCommande.etat !== devisConf.ETAT_BROUILLON
        && (this.devisCommande.sousType === devisConf.SOUS_TYPE_NORMAL
        || this.devisCommande.sousType === devisConf.SOUS_TYPE_AVOIR
        || this.devisCommande.sousType === devisConf.SOUS_TYPE_AVOIR_SUR_ACOMPTE
        || this.devisCommande.sousType === devisConf.SOUS_TYPE_ACOMPTE);
    },
    activeButtonEtLien() {
      return this.checkIfCurrentSociety(this.devisCommande.societeId);
    },
    exportExcelQuery() {
      return {
        typeDonnee: this.constantes.EXPORT_EXCEL_LIGNE_FACTURE,
        typeExport: null,
        filtres: {
          Query: this.lastPayload,
          sorting: 'ordre asc',
        },
      };
    },
    lastPayload() {
      return {
        ids: this.devisCommande?.lignesCommande.flatMap(
          ligne => [ligne.id, ligne.lignesCommande.map(sousligne => sousligne.id)])
          .flatMap(id => id),
      };
    },
    modulePlanMediaActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.modulePlanMedia.key);
    },
    moduleCBADiaporama() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.diaporamaCBA.key);
    },
    factureTags() {
      return (this.devisCommande.sens === devisConf.SENS_VENTE
        && this.devisCommande?.tags?.map(t => t.tag)) ?? [];
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
      loadParametres: 'loadParametres',
    }),
    ...permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...Commandes.mapMutations({
      setCommandeCourant: SET_COMMANDE,
    }),
    ...Attachments.mapActions({
      setAttachmentContext: 'setContext',
      setAttachmentElementId: 'setElementId',
    }),
    async copy() {
      this.setCommandeCourant(copyFacture(this.devisCommande));
      await this.$router.push({ name: 'm.bodac.factures' });
    },
    async edition(donnees) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.errorEdition.champsVide = [];
        this.errorEdition.messagesChampsVide = [];
        this.errorEdition.messages = [];
        this.errorEdition.haveError = false;
        const response = await edition({
          ids: [this.detailDevisCommande.id],
          extension: donnees.format,
          typeDonnee: donnees.typeDonnee,
          typeEdition: donnees.typeEdition ? donnees.typeEdition : '',
          parametresAdditionnels: {
            typeSource: 'dcf',
            societeId: this.detailDevisCommande.generalInfos.societeId,
            ...(donnees.typeDonnee === TYPE_DONNEE_DIAPORAMA && { isCBA: true }),
          },
        });
        const link = this.$refs.lienDownload;
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
        this.popUpEdition = false;
        loadingComponent.close();
      } catch (e) {
        if (e.response) {
          const errorResponseString = await readErrorBlobRequest(e.response.data);
          const response = JSON.parse(errorResponseString);
          validationDevisCommande({ data: response },
            this.errorEdition.messages,
            null,
            devisConf.TYPE_FACTURE);
          validationGeneral(this.$i18n, { data: response }, this.errorEdition.champsVide,
            this.errorEdition.messages, this.errorEdition.messagesChampsVide, translate);
          this.errorEdition.haveError = true;
          loadingComponent.close();
          return;
        }
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
    async generateEcritureComptable() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await generateByFacture(this.detailDevisCommande.id, TYPE_VENTE);
        this.ecritures = (await getByFacture(this.devisCommande.id, this.devisCommande.sens))
          .data.result;
        messageSucces(this.$t('detailFacture.messages.success.generateEcriture'));
      } catch (e) {
        messageErreur(this.$i18n);
        throw (e);
      } finally {
        loadingComponent.close();
      }
    },
    onNewPayeurSelected(index) {
      this.payeurSelected = this.detailDevisCommande.payeurs[index];
    },
    rechargementSuiteSuppression() {
      this.$router.push({ name: 'l.bodac.factures' });
    },
    annulationFacture() {
      this.popUpAvoir = true;
    },
    async checkReferencesToCommande(facture) {
      if ((facture.references && facture.references.length > 0)
        || !facture.lignesCommande.some((ligne) => {
          return ligne.commandeId;
        })) return;
      const commandesIds = [...new Set(facture.lignesCommande
        .filter(ligne => ligne.commandeId)
        .map((ligne) => {
          return ligne.commandeId;
        }))];
      const params = {
        query: {
          societeId: facture.societeId,
          ids: commandesIds,
          sens: devisConf.SENS_VENTE,
        },
        maxResultCount: NO_PAGINATION,
      };
      const commandes = (await getAll(params)).data.result.items;
      facture.references = commandes;
    },
    popUpSolderManuellement() {
      this.openPopUpPrevention = true;
    },
    closePopupSolderManuellement() {
      this.openPopUpPrevention = false;
      this.isErrorPopup = false;
      this.messagesPopup = [''];
    },
    async solderManuellement() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const ids = [];
        ids.push(this.devisCommande.id);
        await pSolderManuellement(ids);
        this.openPopUpPrevention = false;
        loadingComponent.close();
        this.$router.go(0);
      } catch (e) {
        loadingComponent.close();
        if (e.response.data.error) {
          this.messagesPopup = [''];
          validationFacture(e.response, this.messagesPopup);
          this.isErrorPopup = true;
          return;
        }
        messageErreur(this.$i18n);
        throw e;
      }
    },
    async loadFacture(id) {
      const facture = (await get(id)).data.result;
      if (facture.etat === devisConf.ETAT_ANNULER) {
        await this.checkReferencesToCommande(facture);
      }
      if (facture.planMediaId && this.modulePlanMediaActive) {
        facture.planMedia = (await getPlanMedia(facture.planMediaId)).data.result;
      }
      this.devisCommande = facture;
      this.factureASupp.push(this.devisCommande);
      await this.setAttachmentElementId({ id: this.devisCommande.id });
      this.devisCommande.echeancierPaiement = await getInfoEcheancierPaiement(
        this.devisCommande.echeancierPaiement,
      );
      const tempoDetailDevisCommande = detailDevisCommande(this.devisCommande);
      tempoDetailDevisCommande.destinataireComptable.compteComptable = (
        await getTiers(tempoDetailDevisCommande.destinataireComptable.tiersId)
      ).data.result.compteComptable;
      this.detailDevisCommande = tempoDetailDevisCommande;
      this.payeurSelected = this.detailDevisCommande.payeurs[0];
    },
    async loadFactureAchat() {
      if (this.isFactureBailleur || !siteHasHolding()) return;
      const societe = this.societesInformations.find((s) => s.id === this.devisCommande.societeId);
      if (!societe) return;
      this.facturesAchat = await loadFactureAchatVenteInterne(
        this.devisCommande, societe.listeSocieteTiers,
      );
    },
    closePopupAnnulerSoldeManuel() {
      this.openPopUpAnnulerSolde = false;
      this.isErrorPopup = false;
      this.messagesPopup = [];
    },
    async annulerSoldeManuelFacture() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await annulerSoldeManuel(this.devisCommande.id);
        this.openPopUpAnnulerSolde = false;
        loadingComponent.close();
        this.$router.go(0);
      } catch (e) {
        loadingComponent.close();
        if (e.response.data.error) {
          this.messagesPopup = [];
          validationFacture(e.response, this.messagesPopup);
          this.isErrorPopup = true;
          return;
        }
        messageErreur(this.$i18n);
        throw e;
      }
    },
    async exporterLigneVente() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const response = await exportExcel(this.exportExcelQuery);
        const link = this.$refs.lienDownload;
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
        loadingComponent.close();
      } catch (e) {
        if (this.errorManager) this.errorManager(e);
        else messageErreur(this.$i18n, this.$i18n.t('general.messages.error.excelError'));
        loadingComponent.close();
        throw e;
      }
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.$bus.$on('new-payeur-selected', this.onNewPayeurSelected);
      await this.setAttachmentContext({ module: 'Facture' });
      await this.loadParametres([PARAMETRES_KEYS.categorieGroupeProduitDeductible]);
      await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.modulePresse.key,
        PARAMETRES_INTERNE_KEYS.moduleFactor.key,
        PARAMETRES_INTERNE_KEYS.modulePlanMedia.key,
        PARAMETRES_INTERNE_KEYS.blocageFiltreCommercial.key,
        PARAMETRES_INTERNE_KEYS.diaporamaCBA.key,
        PARAMETRES_INTERNE_KEYS.achatAASpe.key,
      ]);
      await this.loadFacture(this.$route.params.id);
      this.ecritures = (await getByFacture(this.devisCommande.id, this.devisCommande.sens))
        .data.result;
      if (this.devisCommande.interne === true) {
        const routeName = this.devisCommande.sens === devisConf.SENS_VENTE ? 'c.bodac.factures-venteInterne' : 'c.bodac.factures-achatVenteInterne';
        await this.$router.push({ name: routeName, params: { id: this.devisCommande.id } });
        loadingComponent.close();
        return;
      }
      await this.loadFactureAchat();
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw (e);
    }
    this.setInformationPage(this.$t('pageGeneral.detail', { item: this.detailDevisCommande.code }));
  },
  destroyed() {
    this.$bus.$off('new-payeur-selected', this.onNewPayeurSelected);
  },
};
</script>
